import translationsFileMacro from '@cld/intl/loadMessages.macro';

export { messages } from './messages';
export const loadMessages = translationsFileMacro('./');
